import React, { Component, createRef } from 'react';
import classNames from 'classnames';
import styles from './tag-autocomplete.styl';
import { Autocomplete, AutocompleteItem, AutocompleteProps } from '../autocomplete/autocomplete';
import { Tag } from '../tag/tag';

export type TagAutocompleteItem = AutocompleteItem;

export interface TagAutocompleteProps extends AutocompleteProps {
  selectedItem?: AutocompleteItem;
  onTagClick: (tag: AutocompleteItem) => void;
}

export class TagAutocomplete extends Component<TagAutocompleteProps> {
  private autocompleteRef = createRef<Autocomplete>();

  constructor(props: any) {
    super(props);
  }

  private renderTag = () => {
    const { selectedItem, onTagClick } = this.props;

    if (!selectedItem) {
      return null;
    }

    return (
      <div className={classNames(styles.tagsContainer)}>
        <Tag
          value={selectedItem.value}
          label={selectedItem.label}
          onClick={() => {
            onTagClick(selectedItem);
          }}
        />
      </div>
    );
  };

  public focus = () => {
    if (!this.autocompleteRef.current) {
      return;
    }

    this.autocompleteRef.current.focus();
  };

  render() {
    const {
      id,
      title,
      value,
      isOpen,
      hasError,
      errorMessage,
      showRequiredMark,
      onBlur,
      onFocus,
      onChange,
      suggestions,
      onSelect,
      disabled,
      minSymbolsCountToStartSearch,
    } = this.props;
    return (
      <div className={classNames(styles.tagsAutocomplete)}>
        {this.renderTag()}
        <Autocomplete
          ref={this.autocompleteRef}
          id={id}
          title={title}
          isOpen={isOpen}
          hasError={hasError}
          value={value}
          suggestions={suggestions}
          onChange={onChange}
          onSelect={onSelect}
          onFocus={onFocus}
          onBlur={onBlur}
          errorMessage={errorMessage}
          showRequiredMark={showRequiredMark}
          disabled={disabled}
          minSymbolsCountToStartSearch={minSymbolsCountToStartSearch}
        />
      </div>
    );
  }
}
